module.exports = __webpack_public_path__ + "img/wellness.ca1cb7f8.svg";